<div class="modal-content" *ngIf="basketOrderList && basketOrderList.length > 0">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <h4 class="modal-title" jhiTranslate="modals.customerConfirmationDifferedPayment.title"></h4>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger d-flex flex-row align-items-center">
      <jhi-bary-icon icon="exclamation-circle" [faDirective]="FAS" size="3x" class="mr-2 mr-sm-3"></jhi-bary-icon>
      <div>
        <div
          jhiTranslate="modals.customerConfirmationDifferedPayment.subTitle.outstandingPayment"
          [translateValues]="{ outstandingPayment: deferredBillsNoPaidAmountCumulated }"
        ></div>
        <div
          [jhiTranslate]="
            basketOrderList.length == 1
              ? 'modals.customerConfirmationDifferedPayment.subTitle.deferredBillsNoPaidBillnumber'
              : 'modals.customerConfirmationDifferedPayment.subTitle.deferredBillsNoPaidBillnumbers'
          "
          [translateValues]="{ deferredBillsNoPaidBillnumbers: deferredBillsNoPaidBillNumbers }"
        ></div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button [outline]="true" color="primary" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ cancel: true })" class="mr-2"></jhi-bary-button>
    <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'BTN.CONFIRM' | translate" data-id-cypress="confirm-update" color="primary"></jhi-bary-button>
  </div>
</div>
